export const Tropes = [
    "One Bed / Sharing a Bed",
    "Body Swap",
    "Fake Dating / Fake Relationship / Pretend Couple",
    "Secret Crush",
    "Amnesia",
    "Road Trip",
    "Bodyguard",
    "Criminals",
    "Kidnapping",
    "Friends with Benefits",
    "Drunken Confessions",
    "First Kiss",
    "Marriage Proposal",
    "Love Potion / Love Spell",
    "Accidental Marriage",
    "Arranged Marriage",
    "Marriage of Convenience",
    "Blind Date",
    "Breakup",
    "Confessions",
    "Dating",
    "Eventual Romance",
    "Falling in Love",
    "Established Relationship",
    "Slow Burn / Slow Romance"
];

export const Relationship_Dynamics = [
    "Friends to Lovers",
    "Enemies to Lovers",
    "Strangers to Lovers",
    "Mutual Pining / Pining",
    "Unrequited Love / One-Sided Attraction",
    "Secret Relationship",
    "Idiots in Love",
    "Dorks in Love",
    "OTP (One True Pairing)",
    "Long-Distance Relationship",
    "Long-Term Relationship",
    "First Love",
    "Love at First Sight",
    "Love/Hate",
    "Love Confessions",
    "Love Triangle",
    "Heartbreak",
    "Soulmates / Soulmate AU",
    "Tsundere (and other -deres)",
    "Battle Couple",
    "Star-Crossed Lovers",
    "Enemies to Lovers Fallout",
    "Exes Reuniting",
    "Unfaithfulness / Infidelity",
    "Rival Love Interest / Jealous Third Party",
    "Love Across Enemy Lines",
    "Family Pressure / Disapproval",
    "Cultural / Class Divide",
    "Coworkers"
];

export const Conflict = [
    "Jealousy",
    "Forbidden Love",
    "Injury",
    "Sick Fic",
    "Trapped",
    "Rivals",
    "Miscommunication / Misunderstanding",
    "Secret Identity",
    "Hidden Past",
    "Revenge Plot",
    "Betrayal",
    "Blackmail",
    "Unwanted Engagement",
    "Wrong Place, Wrong Time",
    "One-Sided Deal",
    "Moral Dilemma",
    "Tragic Backstory Resurfacing",
    "Secrets Revealed at the Worst Time",
    "Forbidden Workplace Romance",
    "Political Intrigue"
];

export const Setting_Generes = [
    "Medieval",
    "Royalty",
    "Sci-Fi",
    "Spies",
    "Time Travel",
    "Vampires",
    "Hero/Villain",
    "Mafia",
    "Corporate",
    "Omegaverse",
    "Paranormal",
    "Supernatural Horror",
    "Apocalypse / Post-Apocalypse",
    "Historical",
    "Wild West",
    "Mythology-Inspired",
    "High School / College",
    "Alternate Sport",
    "Pirates / Seafaring",
    "Space Opera",
    "Detective / Noir",
    "Medical / Hospital",
    "Workplace",
    "Small Town",
    "Big City / Urban",
    "Holiday / Seasonal"
];